import React, { Fragment } from "react";
import NowPlaying from "../components/NowPlaying";
import Popular from "../components/Popular";
import TopRated from "../components/TopRated";
import Upcoming from "../components/Upcoming";
import "../assets/styles/components/Layout.scss";

const Movies = () => (
  <Fragment>
    <div className="container">
      <NowPlaying />
      <Upcoming/>
      <Popular />
      <TopRated />
    </div>
  </Fragment>
);

export default Movies;
